module.exports = __webpack_public_path__ + "static/media/psd.6a046367.png";